import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  map, size, sortBy, filter,
} from 'lodash';
import {
  dateFormats, calculateDateDiff, TIMELINE_CONSTANTS, NUMERIC_VALUE,
} from '../../../../utils';

function OfferCampaignTimeline(props) {
  const { offerData, setScrollToSegmentId } = props;

  const segmentLength = offerData && offerData.campaignTimeline.length;

  const lastSegmentEndDate = () => {
    if (offerData) {
      const lastArraySize = size(offerData && offerData.campaignTimeline);
      const lastSegmentObj = offerData.campaignTimeline[lastArraySize - 1];
      return lastSegmentObj.endDate;
    }
    return null;
  };

  const getTimelineTitle = () => {
    const DateDiff = calculateDateDiff(new Date(), offerData && offerData.offerMaxDate);
    if (DateDiff === TIMELINE_CONSTANTS.EXPIRED) {
      return 'Expired';
    }
    return 'Ongoing campaign';
  };

  const renderSegmentTimeline = () => {
    const getStartDateArray = offerData && offerData.campaignTimeline.map((segment) => ({
      _id: segment._id,
      startDate: segment.startDate,
    }));
    const sortedArray = sortBy(getStartDateArray, 'startDate');
    const filteredSortedArray = filter(sortedArray, (item, index) => index !== NUMERIC_VALUE.ZERO);

    const renderFilteredArrayTimeline = () => map(filteredSortedArray, (item, index) => item && (
      <div className={`offer-timeline-row cursor-pointer ${calculateDateDiff(new Date(), item.startDate) === TIMELINE_CONSTANTS.DUE_TODAY ? 'ongoing' : ''}`} key={index}>
        <div className="offer-timeline-head" onClick={() => { setScrollToSegmentId(item._id); }}>
          <h3>{moment(item.startDate).format(dateFormats.DAY_DATE_WITHOUT_YEAR)}</h3>
          {calculateDateDiff(new Date(), item.startDate) === TIMELINE_CONSTANTS.DUE_TODAY
              && <p className="expires icon-red">Due today</p>}
        </div>
      </div>
    ));

    if (segmentLength < NUMERIC_VALUE.TWO) {
      return (
        <div className={`offer-timeline-row cursor-pointer ${calculateDateDiff(new Date(), sortedArray[0].startDate) === TIMELINE_CONSTANTS.DUE_TODAY ? 'ongoing' : ''}`}>
          <div className="offer-timeline-head" onClick={() => { setScrollToSegmentId(sortedArray[0]._id); }}>
            <h3>{offerData && moment(sortedArray[0].startDate).format(dateFormats.DAY_DATE_WITHOUT_YEAR)}</h3>
            <p>Campaign starts</p>
            {calculateDateDiff(new Date(), sortedArray[0].startDate) === TIMELINE_CONSTANTS.DUE_TODAY
              && <p className="expires icon-red">Due today</p>}
          </div>
        </div>
      );
    }

    return (
      <>
        <div className={`offer-timeline-row cursor-pointer ${calculateDateDiff(new Date(), sortedArray[0].startDate) === TIMELINE_CONSTANTS.DUE_TODAY ? 'ongoing' : ''}`}>
          <div className="offer-timeline-head" onClick={() => { setScrollToSegmentId(sortedArray[0]._id); }}>
            <h3>{offerData && moment(sortedArray[0].startDate).format(dateFormats.DAY_DATE_WITHOUT_YEAR)}</h3>
            <p>Campaign starts</p>
            {calculateDateDiff(new Date(), sortedArray[0].startDate) === TIMELINE_CONSTANTS.DUE_TODAY
              && <p className="expires icon-red">Due today</p>}
          </div>
        </div>
        {renderFilteredArrayTimeline()}
      </>
    );
  };

  return (
    <div className="offer-artist-wrapper">
      <Scrollbars
        style={{ height: '100%' }}
        thumbMinSize={30}
      >
        <div className="recommended-artist">
          <h2>{getTimelineTitle()}</h2>
          <div className="offer-timeline">
            {renderSegmentTimeline()}
            <div className={`offer-timeline-row cursor-pointer ${calculateDateDiff(new Date(), lastSegmentEndDate()) === TIMELINE_CONSTANTS.DUE_TODAY ? 'ongoing' : ''}`}>
              <div className="offer-timeline-head">
                <h3>{offerData && moment(offerData.offerMaxDate).format(dateFormats.DAY_DATE_WITHOUT_YEAR)}</h3>
                <p>Campaign ends</p>
              </div>
            </div>
          </div>
        </div>
      </Scrollbars>
    </div>
  );
}
OfferCampaignTimeline.propTypes = {
  offerData: PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    clientName: PropTypes.string,
    campaignType: PropTypes.string,
    viewType: PropTypes.string,
    description: PropTypes.string,
    clientLogo: PropTypes.string,
    campaignTimeline: PropTypes.arrayOf(PropTypes.shape({
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      description: PropTypes.string,
      segmentId: PropTypes.string,
      shareType: PropTypes.shape({
        facebook: PropTypes.bool,
        instagram: PropTypes.bool,
        twitter: PropTypes.bool,
        youtube: PropTypes.bool,
        spotify: PropTypes.bool,
      }),
    })),
    segmentParticipants: PropTypes.arrayOf(PropTypes.shape({
      segmentId: PropTypes.string,
    })),
    basePrice: PropTypes.number,
    createContract: PropTypes.string,
    createdAt: PropTypes.string,
    offerMinDate: PropTypes.string,
    offerMaxDate: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })),
  }),
  setScrollToSegmentId: PropTypes.func,
};

OfferCampaignTimeline.defaultProps = {
  offerData: null,
  setScrollToSegmentId: null,
};

export default OfferCampaignTimeline;
